module.exports = __webpack_public_path__ + "static/icon-light-7eca112349afd23917dabdce3a972998.svg";